import { render, staticRenderFns } from "./FirmaDetay.vue?vue&type=template&id=d0f106a8&scoped=true&"
import script from "./FirmaDetay.vue?vue&type=script&lang=js&"
export * from "./FirmaDetay.vue?vue&type=script&lang=js&"
import style0 from "./FirmaDetay.vue?vue&type=style&index=0&id=d0f106a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f106a8",
  null
  
)

export default component.exports